/**
 * Único caminho de erro da pesquisa: monitoramento sim, tela não (RNF-02).
 *
 * O contexto aceito é deliberadamente estreito — `correlacaoId` e `desfecho` — e a
 * mensagem do erro é descartada. O comentário é texto livre de produto jurídico e
 * vai conter nome de parte, número de processo e valor de acordo; a mensagem de um
 * erro de rede pode carregar o corpo da requisição, então repassá-la ao RUM
 * publicaria exatamente o que a RNF-01 proíbe. O que sobra basta para achar a
 * resposta no painel e cruzar com a linha da plataforma.
 */
interface ContextoErroPesquisa {
  correlacaoId: string;
  desfecho?: string;
}

export function registrarErroDePesquisa(
  acao: string,
  erro: unknown,
  contexto: ContextoErroPesquisa,
): void {
  if (typeof window === 'undefined') return;

  const tipoDoErro = erro instanceof Error ? erro.name : typeof erro;

  void import('@datadog/browser-rum')
    .then(({ datadogRum }) => {
      datadogRum.addAction(acao, { ...contexto, tipoDoErro });
    })
    .catch(() => {});
}
